{
  "wellbore_uwi": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "UWI",
      "width": 175
    }
  },
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true
    }
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true
    }
  },
  "recompletion_date": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Recompletion Date",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "total_production_in_month_before_boepd": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Before Recomplete Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "total_production_in_month_after_boepd": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "After Recomplete Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "production_month_before": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Before Recomplete Production Month",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "production_month_after": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "After Recomplete Production Month",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "on_prod_date": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "On Production Date",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation",
      "width": 100,
      "isShownByDefault": true
    }
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "width": 100,
      "isShownByDefault": true
    }
  },
    "well_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Status",
      "width": 100,
      "isShownByDefault": true
    }
  },
}
